import React, { useState, useEffect, useRef } from "react";
import { Table, Dropdown } from "antd";
import { useHistory } from "react-router-dom";
import {
  fetchAssetList,
  deleteAsset,
  fetchAssetByID,
  TurnUnvailable,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import closeIcon from "../../assets/icons/x-circle.svg";
import deleteIcon from "../../assets/icons/DeleteIcon.svg";
import location from "../../assets/icons/location1.svg";
import tool from "../../assets/icons/tool.svg";
import aperture from "../../assets/icons/aperture.svg";
import Show from "../../assets/icons/Notshow.svg";
import Doc from "../../assets/icons/Document_2.svg";
import downarrow from "../../assets/icons/downarrow.svg";
import styles from "./ListTable.module.css";
import ReactPaginate from "react-paginate";
import { BsChevronDown } from "react-icons/bs";
import { Radio } from "@mui/material";
import { default as style } from "styled-components";
import Calendericon from "../../assets/icons/Calendar with interaction.svg";
import AppDatePicker from "../../components/Common/AppDatePicker";
import AssemblyInstructionsPopup from "./AssemblyInstructions/AssemblyInstructionsPopup";

// style={{
//     backgroundColor: "white",
//     borderRadius: "9px",
//     width: "18px",
//     height: "18px",
//   }}

function ListTable({ className, sortBy, query }) {
  const history = useHistory();
  const dispatch = useDispatch();

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Assets-List").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const [loading, setLoading] = useState(false);
  const [dropDownItemsHover, setDropDownItemsHover] = useState(false);
  const [activePageOption, setActivePageOption] = useState(false);
  const [sortby, setSortBy] = useState("");
  const [querystring, setQuerystring] = useState("");
  const [perPageRequired, setPerPageRequired] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalPages, setTotalPages] = useState(10);
  const [refetch, setrefetch] = useState(true);

  const [assemblyModal, showAssemblyModal] = useState(false);

  const [activeSort, setActiveSort] = useState("Assets Name");
  const [isSortDropdownOpen, setIsSortDropdownOpen] = useState(false);
  const [showPerPageDropDown, setShowPerPageDropDown] = useState(false);
  const [listInfo, setListInfo] = useState({
    currentPage: 0,
    perPage: 10,
    totalRecords: 0,
  });

  const [showSecondMenu, setShowSecondMenu] = useState(true);
  const [type, setType] = useState("Definitive");
  const [reason, setReason] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const BpIcon = style("span")(() => ({
    borderRadius: "50%",
    width: 16,
    height: 16,
    boxShadow:
      "dark" === "dark"
        ? "0 0 0 1px rgb(16 22 26 / 40%)"
        : "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: "dark" === "dark" ? "#FFFFFF" : "#f5f8fa",
    backgroundImage:
      "dark" === "dark"
        ? "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))"
        : "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    ".Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: "dark" === "dark" ? "#FFFFFF" : "#ebf1f5",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background:
        "dark" === "dark" ? "rgba(57,75,89,.5)" : "rgba(206,217,224,.5)",
    },
  }));

  const BpCheckedIcon = style(BpIcon)({
    backgroundColor: "#00246A",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 0,
      height: 16,
      backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: "#106ba3",
    },
  });

  const SetAssetUnavailibility = async (obj) => {
    var data = {
      assetId: obj.assetId,
    };

    if (type === "Temporary") {
      data["isTemporary"] = true;
      data["startDate"] = startDate;
      data["endDate"] = endDate;
    } else if (type === "Definitive") {
      data["isDefinitive"] = true;
      data["reason"] = reason;
    }

    var result = await TurnUnvailable(data);

    if (result) {
      refreshTableListData();
    }

    // {
    //   "assetId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   "isDefinitive": true,
    //   "isTemporary": true,
    //   "reason": "string",
    //   "startDate": "2024-03-04T07:21:47.780Z",
    //   "endDate": "2024-03-04T07:21:47.780Z"
    // }
  };

  const closeDrop = useRef(null);
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (closeDrop.current && !closeDrop.current.contains(event.target)) {
      setOpenAssetDrop(false);
      // setArrowOptionsRotate(false);
    }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  const [openAssetDrop, setOpenAssetDrop] = useState(false);
  const [selectedAssetID, setSelectedAssetID] = useState("");

  const menu = (obj) => (
    <div
      ref={closeDrop}
      style={{
        backgroundColor: "#FAFAFA",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "10px",
        padding: "15px",
        borderRadius: "10px",
        position: "relative",
        paddingTop: "40px",
        marginTop: "-30px",
        zIndex: "9",
        border: "0.5px solid rgb(212, 212, 212)",
        boxShadow: "0px 5px 7px 0px #d4d4d4",
      }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "3px",
          position: "absolute",
          top: "10px",
          right: "15px",
          cursor: "pointer",
          width: "25px",
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setShowSecondMenu(false);
          setOpenAssetDrop(false);
        }}
      >
        {new Array(3).fill(true).map((item, index) => (
          <div
            style={{
              backgroundColor: "#1F1F1F",
              width: "5px",
              height: "5px",
              borderRadius: "5px",
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setShowSecondMenu(false);
              setOpenAssetDrop(false);
            }}
          ></div>
        ))}
      </div>

      {showSecondMenu && (
        <div
          style={{
            position: "absolute",
            right: "16vw",
            background: "white",
            top: "-15vh",
            zIndex: "999",
            width: "14vw",
            minHeight: "40vh",
            borderRadius: "5px",
            padding: "10px",
            border: "0.5px solid rgb(212, 212, 212)",
            boxShadow: "0px 5px 7px 0px #d4d4d4",
          }}
        >
          <div className="row selection">
            <div className="col">
              {/* Turn Unavailable */}
              {t("Turn Unavaiable")}
            </div>
            <div
              className="col-3"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setShowSecondMenu(false);
              }}
            >
              {" "}
              <img src={closeIcon} alt="" />
            </div>
          </div>
          <div className="fc">
            <div style={{ display: "flex" }}>
              <Radio
                checked={type === "Definitive"}
                onClick={() => setType("Definitive")}
                value="Definitive"
                name="radio-buttons"
                inputProps={{ "aria-label": "A" }}
                checkedIcon={<BpCheckedIcon />}
                icon={<BpIcon />}
                size="small"
                disableRipple={true}
                disableFocusRipple={true}
                sx={{
                  ":hover": {
                    backgroundColor: "transparent",
                  },
                }}
              />
              <p
                onClick={() => setType("Definitive")}
                style={{
                  fontSize: "x-small",
                  marginTop: "10px",
                  cursor: "pointer",
                }}
              >
                Definitive
              </p>
            </div>
            <textarea
              name="description"
              className={"text-description-pop-1 w-auto"}
              style={{
                marginLeft: "8px",
                maxWidth: "clamp(155px, 8.204vw, 10.204vw)",
              }}
              placeholder={"Type a reason"}
              // value={""}
              onChange={(e) => {
                setReason(e.target.value);
              }}
            />
            <div>
              <div style={{ display: "flex" }}>
                <Radio
                  checked={type === "Temporary"}
                  value="Temporary"
                  name="radio-buttons"
                  inputProps={{ "aria-label": "A" }}
                  checkedIcon={<BpCheckedIcon />}
                  onClick={() => setType("Temporary")}
                  icon={<BpIcon />}
                  size="small"
                  disableRipple={true}
                  disableFocusRipple={true}
                  sx={{
                    ":hover": {
                      backgroundColor: "transparent",
                    },
                  }}
                />
                <p
                  onClick={() => setType("Temporary")}
                  style={{
                    fontSize: "x-small",
                    marginTop: "10px",
                    cursor: "pointer",
                  }}
                >
                  Temporary
                </p>
              </div>

              <label
                style={{
                  display: "flex",
                  width: "94%",
                  marginLeft: "8px",
                }}
              >
                <p style={{ fontSize: "12px", opacity: ".5" }}>
                  From&nbsp;&nbsp;&nbsp;
                </p>
                <img
                  style={{ height: "15px", marginTop: "3px" }}
                  src={Calendericon}
                  alt="calender"
                />
                <AppDatePicker
                  onSelect={(d, event) => {
                    event.preventDefault();
                  }}
                  inputClassNames={"ms-1 equipment-date"}
                  dateFormat="dd/MM/yyyy"
                  className="calender-icon-date"
                  onChange={setStartDate}
                  placeholderText="dd/mm/yyyy"
                  selected={startDate}
                />
              </label>
              <label
                style={{
                  display: "flex",
                  marginLeft: "7px",
                  width: "94%",
                }}
              >
                <p style={{ fontSize: "12px", opacity: ".5" }}>
                  To&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </p>
                <img
                  style={{ height: "16px", marginTop: "3px" }}
                  src={Calendericon}
                  alt="calender"
                />
                <AppDatePicker
                  onSelect={(d, event) => {
                    event.preventDefault();
                  }}
                  inputClassNames={"ms-1 equipment-date"}
                  dateFormat="dd/MM/yyyy"
                  className="calender-icon-date"
                  onChange={setEndDate}
                  placeholderText="dd/mm/yyyy"
                  selected={endDate}
                />
              </label>
              <div className="confirm-btn-div">
                <button
                  className="confirm-btn"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setShowSecondMenu(false);
                    SetAssetUnavailibility(obj);
                    setOpenAssetDrop(false);
                  }}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Turn Availibility */}
      <div
        className="selection"
        style={{
          display: obj.isAssetUnavailabl ? "none" : "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "15px",
          cursor: "pointer",
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setShowSecondMenu(true);
        }}
      >
        <img
          src={Show}
          alt=""
          style={{
            color: dropDownItemsHover ? "#323232" : "inherit",
          }}
        />
        <p
          style={{
            margin: 0,
            color: dropDownItemsHover ? "#323232" : "inherit",
          }}
          onMouseEnter={() => {
            setDropDownItemsHover(true);
          }}
          onMouseLeave={() => {
            setDropDownItemsHover(false);
          }}
        >
          {/* Turn Unavailable */}
          {t("Turn Unavaiable")}
        </p>
      </div>

      {/* Create Maintainace */}
      <div
        className="selection"
        style={{
          display: obj.isAssetUnavailabl ? "none" : "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "15px",
          cursor: "pointer",
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setShowSecondMenu(false);

          var data = {
            action: "CREATEMAINTAINANCE",
          };

          window.localStorage.setItem("assetId", obj.assetId);
          window.localStorage.setItem("assetId", obj.assetId);
          localStorage.setItem("activeTab", "maintenance");

          if (obj.assetType === "Part")
            history.push("/asset-management/update-part", data);
          else if (obj.assetType === "Equipment")
            history.push("/asset-management/update-equipment", data);
          else history.push("/asset-management/update-facility", data);

          // history.push("/asset-management/update-asset", data);
        }}
      >
        <img
          src={tool}
          alt=""
          style={{
            color: dropDownItemsHover ? "#323232" : "inherit",
          }}
        />
        <p
          style={{
            margin: 0,
            color: dropDownItemsHover ? "#323232" : "inherit",
          }}
          onMouseEnter={() => {
            setDropDownItemsHover(true);
          }}
          onMouseLeave={() => {
            setDropDownItemsHover(false);
          }}
        >
          {/* Create Maintainace */}
          {t("Create Maintence")}
        </p>
      </div>

      {/* Create PO */}
      <div
        className="selection"
        style={{
          display: obj.isAssetUnavailabl ? "none" : "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "15px",
          cursor: "pointer",
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setShowSecondMenu(false);
          history.push({
            pathname: "/view-purchasing-order-assets",
            state: {
              from: "Asset_List_Screen",
              history_AssetName: obj.assetName,
              history_AssetID: obj.assetId,
            },
          });
        }}
      >
        <img
          src={Doc}
          alt=""
          style={{
            color: dropDownItemsHover ? "#323232" : "inherit",
          }}
        />
        <p
          style={{
            margin: 0,
            color: dropDownItemsHover ? "#323232" : "inherit",
          }}
          onMouseEnter={() => {
            setDropDownItemsHover(true);
          }}
          onMouseLeave={() => {
            setDropDownItemsHover(false);
          }}
        >
          {/* Create PO */}
          {t("Create PO")}
        </p>
      </div>

      {/* Assembly Instruction */}
      <div
        className="selection"
        style={{
          display: obj.isAssetUnavailabl ? "none" : "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "15px",
          cursor: "pointer",
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setShowSecondMenu(false);
          showAssemblyModal(true);
          window.localStorage.setItem("assetId", obj.assetId);
        }}
      >
        <img
          src={aperture}
          alt=""
          style={{
            color: dropDownItemsHover ? "#323232" : "inherit",
          }}
        />
        <p
          style={{
            margin: 0,
            color: dropDownItemsHover ? "#323232" : "inherit",
          }}
          onMouseEnter={() => {
            setDropDownItemsHover(true);
          }}
          onMouseLeave={() => {
            setDropDownItemsHover(false);
          }}
        >
          {/* Assembly Instructions */}
          {t("Assembly instructions")}
        </p>
      </div>

      {/* Delete */}
      <div
        className="selection"
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "15px",
          cursor: "pointer",
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setShowSecondMenu(false);
          setLoading(true);
          dispatch(deleteAsset(obj.assetId));
          setTimeout(() => {
            dispatch(
              fetchAssetList(
                pageNumber,
                perPageRequired,
                activeSort,
                querystring,
              ),
            );
          }, 300);

          setLoading(false);
        }}
      >
        <img
          src={deleteIcon}
          alt=""
          style={{
            color: dropDownItemsHover ? "#323232" : "inherit",
          }}
        />
        <p
          style={{
            margin: 0,
            color: dropDownItemsHover ? "#323232" : "inherit",
          }}
          onMouseEnter={() => {
            setDropDownItemsHover(true);
          }}
          onMouseLeave={() => {
            setDropDownItemsHover(false);
          }}
        >
          {/* Delete */}
          {t("Delete")}
        </p>
      </div>
    </div>
  );

  const columns = [
    {
      key: "assetName",
      dataIndex: "assetName",
      // title: "Asset Name",
      title: t("Asset Name"),
      width: "30%",
      render: (name, obj) => {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "10px",
              cursor: "pointer",
            }}
          >
            <img
              src={
                obj.assetType === "Part"
                  ? tool
                  : obj.assetType === "Equipment"
                    ? aperture
                    : location
              }
              alt=""
              style={{
                width: "16px",
                height: "16px",
                marginRight: "15px",
                cursor: "pointer",
              }}
            />
            <div>{name}</div>
          </div>
        );
      },
    },
    {
      key: "description",
      dataIndex: "description",
      // title: "Asset Description",
      title: t("Asset Description"),
      width: "30%",
    },
    {
      key: "internalId",
      dataIndex: "internalId",
      // title: "Internal ID",
      title: t("Internal ID"),
      width: "10%",
    },
    {
      key: "assetLocation",
      dataIndex: "assetLocation",
      // title: "Asset Location",
      title: t("Asset Location"),
      width: "15%",
    },
    {
      key: "category",
      dataIndex: "category",
      // title: "Category",
      title: t("Category"),
      width: "30%",
      render: (category, obj) => (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>{category}</div>
          <Dropdown
            overlay={() => menu(obj)}
            disabled={obj.isAssetUnavailabl}
            trigger={"click"}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setShowSecondMenu(false);
              setSelectedAssetID(obj.assetId);
              window.localStorage.setItem("assetList_AssetId", obj.assetId);
            }}
            open={openAssetDrop && selectedAssetID === obj.assetId}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                gap: "3px",
                cursor: "pointer",
                width: "25px",
                pointerEvents: "auto", // to open dropDwn even disabled dropDwn.
              }}
              onClick={(e) => {
                setOpenAssetDrop(true);
              }}
            >
              {new Array(3).fill(true).map((item, index) => (
                <div
                  style={{
                    backgroundColor: "#1F1F1F",
                    width: "5px",
                    height: "5px",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                ></div>
              ))}
            </div>
          </Dropdown>
        </div>
      ),
    },
  ];

  const assetsList = useSelector((state) => state.user.assetList);
  const deleteAssetRes = useSelector((state) => state.user.deleteAsset);

  // useEffect(() => {
  //   dispatch(fetchAssetList(activeSort, querystring, pageNumber + 1, perPageRequired));
  // }, [activeSort, querystring, pageNumber, perPageRequired, refetch]);

  useEffect(() => {
    refreshTableListData();
  }, [listInfo.currentPage, listInfo.perPage, sortBy, query, deleteAssetRes]);

  useEffect(() => {
    const totalRecords = assetsList?.data?.totalCount || 0;
    setListInfo((p) => ({ ...p, totalRecords: totalRecords }));
  }, [assetsList]);

  const refreshTableListData = () => {
    dispatch(
      fetchAssetList({
        pageNumber: listInfo.currentPage + 1,
        perPageRequired: listInfo.perPage,
        sortby: sortBy,
        query: query,
      }),
    );
  };

  // useEffect(() => {

  // }, [listData]);

  const PaginationChange = (event) => {
    setPageNumber(event.selected);
  };

  const handleSortClick = (sortOption) => {
    setActiveSort(sortOption);
    setIsSortDropdownOpen(false);
  };
  const handleDropdownShow = () => {
    setIsSortDropdownOpen(!isSortDropdownOpen);
  };

  const onPageChange = (event) => {
    setListInfo((p) => ({ ...p, currentPage: event.selected }));
  };

  const onPerPageItemSelect = (perPage) => {
    setListInfo((p) => ({ ...p, currentPage: 0, perPage: perPage }));
    setShowPerPageDropDown(false);
  };

  return (
    <>
      <div className="" style={{ marginTop: "0" }}>
        {/* <div className={styles.sort_wrapper}>
          <span className={styles.sort_title}>Sort by</span>
          <div className={styles.sort_dropdown_wrapper}>
            <span className={styles.arrow_wrap}>
              <svg
                stroke="currentColor"
                fill="currentColor"
                stroke-width="0"
                viewBox="0 0 24 24"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M11 8.414V18h2V8.414l4.293 4.293 1.414-1.414L12 4.586l-6.707 6.707 1.414 1.414z"></path>
              </svg>
            </span>
            <div className={styles.sort_dropdown}>
              <button className={styles.sort_btn} onClick={handleDropdownShow}>
                {activeSort}
              </button>
              <div
                className={`${styles.dropdown} ${
                  isSortDropdownOpen ? styles.show : ""
                }`}
              >
                <ul>
                  <li
                    className={
                      activeSort === "Assets Name" ? styles.active : ""
                    }
                    onClick={() => handleSortClick("Assets Name")}
                  >
                    Assets Name
                  </li>
                  <li
                    className={
                      activeSort === "Internal ID" ? styles.active : ""
                    }
                    onClick={() => handleSortClick("Internal ID")}
                  >
                    Internal ID
                  </li>
                  <li
                    className={
                      activeSort === "Assets Location" ? styles.active : ""
                    }
                    onClick={() => handleSortClick("Assets Location")}
                  >
                    Assets Location
                  </li>
                  <li
                    className={activeSort === "Category" ? styles.active : ""}
                    onClick={() => handleSortClick("Category")}
                  >
                    Category
                  </li>
                </ul>
              </div>
            </div>
          </div>


        </div> */}

        <div className={`${className} assets-list-wrapper`}>
          <Table
            columns={columns}
            // dataSource={assetsList?.data?.data}
            dataSource={assetsList?.data?.data?.map((asset) => ({
              // for 3 Dot.
              ...asset,
              assetLocation: (
                <div
                  className="asc-screen-url=asset-management text-dange-r"
                  title={
                    asset?.assetLocation?.length > 10 && asset?.assetLocation
                  }
                  style={{
                    // for 3 dots 👇
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "140px",
                  }}
                >
                  {asset.assetLocation}
                </div>
              ),
            }))}
            pagination={false}
            loading={loading}
            onRow={(record, rowIndex) => {
              return {
                onClick: (event) => {
                  setSelectedAssetID(record.assetId);
                  window.localStorage.setItem("assetId", record.assetId);
                  window.localStorage.setItem("assetId", record.assetId);
                  window.localStorage.setItem(
                    "assetList_AssetId",
                    record.assetId,
                  );
                  localStorage.setItem("activeTab", "general");
                  if (record.assetType === "Part")
                    history.push("/asset-management/update-part");
                  else if (record.assetType === "Equipment")
                    history.push("/asset-management/update-equipment");
                  else history.push("/asset-management/update-facility");
                }, // click row
              };
            }}
            rowClassName={(record) =>
              record.isAssetUnavailabl && "disabled-row"
            }
          />
        </div>
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <p
              className="fw-bold mt-3"
              style={{
                fontSize: "20px",
                color: "#333333",
                display: "flex",
              }}
            >
              <p
                className="table-item mt-1"
                style={{
                  fontWeight: 400,
                  fontSize: "clamp(10px, 0.729vw, 1vw)",
                }}
              >
                {/* Items per page */}
                {t("Items per page")}
              </p>
              <div
                style={{
                  cursor: "pointer",
                  position: "relative",
                  display: "flex",
                  flexDirection: "row",
                  marginTop: "5px",
                }}
                className="ms-4"
              >
                <p
                  className="margin-0"
                  style={{
                    fontSize: "clamp(10px, 0.729vw, 1vw)",
                    fontWeight: "bold",
                    color: "#333333",
                    flexGrow: "1",
                    textTransform: "capitalize",
                  }}
                  onClick={() => setShowPerPageDropDown((p) => !p)}
                >
                  {listInfo.perPage}
                </p>
                <BsChevronDown
                  size={15}
                  style={{
                    flexGlow: "1",
                    color: "#000000",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowPerPageDropDown((p) => !p)}
                  className="down-arrow bi-paperclip ms-2 mt-1"
                />
                {showPerPageDropDown && (
                  <div
                    className="drop-down-member-item d-flex align-items-end p-1"
                    id="lang-drop-down"
                  >
                    <div>
                      {[10, 20, 50]?.map((item, i) => {
                        return (
                          <div>
                            <p
                              key={i}
                              className="margin-0 ms-2 pb-1"
                              style={{
                                opacity: 1,
                                fontSize: "clamp(10px, 0.729vw, 1vw)",
                                fontWeight: "bold",
                                color: `${
                                  item === listInfo.perPage
                                    ? "#95A7C6"
                                    : "#333333"
                                }`,
                              }}
                              onClick={() => onPerPageItemSelect(item)}
                            >
                              {item}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                    <BsChevronDown
                      onClick={() => setShowPerPageDropDown((p) => !p)}
                      size={15}
                      style={{
                        fontWeight: "bold",
                        flexGlow: "1",
                        color: "#000000",
                      }}
                      className="mb-1 ms-1 down-arrow down-arrow-rotate bi-paperclip"
                    />
                  </div>
                )}
              </div>
            </p>
          </div>
          <div>
            <ReactPaginate
              nextLabel=""
              forcePage={listInfo.currentPage}
              disableInitialCallback={true}
              onPageChange={onPageChange}
              pageRangeDisplayed={3}
              marginPagesDisplayed={1}
              pageCount={Math.ceil(listInfo.totalRecords / listInfo.perPage)}
              previousLabel=""
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="d-none"
              nextClassName="d-none"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="app-paginations"
              activeClassName="active"
              renderOnZeroPageCount={null}
            />
          </div>
        </div>
      </div>
      {assemblyModal && (
        <AssemblyInstructionsPopup
          show={assemblyModal}
          onHide={() => showAssemblyModal(false)}
          backdrop="static"
          keyboard={false}
          //  handleCancel={handleCancel}
        />
      )}
    </>
  );
}

export default ListTable;
